import L from "leaflet";
import { MapContainer, MapConsumer, TileLayer, Marker, Popup, useMapEvents } from "react-leaflet";

import { withMainMap } from "./../../../shared/containers/containerMainMap";
import { withMapControl } from "../../../shared/containers/containerMapControl";

import TopRightMapControl from "../../LayerMapCotrol/TopRightMapControl";
import TopLefttMapControl from "../../LayerMapCotrol/TopLeftMapControl";
import BaseLayerMapControl from "../../LayerMapCotrol/BaseLayerMapControl";
import styles from "./carsMap.module.scss";
import { withAppState } from "../../../shared/containers/containerAppState";
import SearchAddressControl from "../../LayerMapCotrol/SearchAddressControl/SearchAddressControl";
import { searchMarkerIconService } from "../../Geocoders/searchMarkerIconService";
import { withGeocoder } from "../../../shared/containers/containerGeocoder";
import { withJobRequests } from "../../../shared/containers/containerJobRequests";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import { OtherMarkerIcons } from "../../../shared/map/OtherMarkerIcons";
import MarkerClusterGroup from "react-leaflet-markercluster";

const jobRequestType = {
  0: "Заявка",
  1: "Установка",
};

const jobRequestTypeColor = {
  0: "#386E93",
  1: "#FF5859",
};

function DoubleClickComponent(props) {
  const { onSelectJobRequest, jobRequestsFilter } = props;
  const { jobRequestType, isWinter } = jobRequestsFilter;

  const mapEvents = useMapEvents({
    dblclick: (e) => {
      const selectJobRecuest = {
        lat: e.latlng.lat,
        lon: e.latlng.lng,
        date: new Date().toISOString(),
        title: "",
        comment: "",
        jobRequestType: jobRequestType === -1 ? 0 : jobRequestType,
        isWinter,
      };

      onSelectJobRequest(selectJobRecuest);
    },
  });

  return null;
}

const JobRequestsMap = (props) => {
  const {
    mapBaseLayer,
    zoom,
    mapCenter,
    mapBounds,
    isSideBarOpen,
    searchMapMarkerLocation,
    dataSearch,
    jobRequests,
    onSelectJobRequest,
    jobRequestsFilter,
  } = props;

  const getIconSearch = (color) => {
    return L.divIcon({
      html: `<div>${searchMarkerIconService.getSeachIcon(color)}</div>`,
      className: "svg-icon",
      iconSize: [60, 60],
      iconAnchor: [30, 60],
    });
  };

  const getIconJobRequest = (type) => {
    const icon = type === 1 ? OtherMarkerIcons.getJobRequestIcon() : OtherMarkerIcons.getJobRequestInstallationIcon();

    return L.divIcon({
      html: `<div>${icon}</div>`,
      className: "svg-icon",
      iconSize: [60, 60],
      iconAnchor: [20, 20],
    });
  };

  const createClusterCustomIcon = (cluster) => {
    return L.divIcon({
      html: `<div>${OtherMarkerIcons.getJobRequestClusterIcon()}</div>`,
      className: `marker-cluster`,
    });
  };

  return (
    <div className={styles.carsMap}>
      <MapContainer
        key={`${mapBaseLayer.name} ${zoom} ${mapCenter.lat} ${mapCenter.lng} ${isSideBarOpen}`}
        crs={mapBaseLayer.crs}
        center={mapCenter}
        zoom={zoom}
        maxZoom={mapBaseLayer.maxZoom}
        minZoom={3}
        zoomControl={true}
        attributionControl={false}
        doubleClickZoom={false}
        scrollWheelZoom={true}
        dragging={true}
        animate={true}
        easeLinearity={0.35}
        className={styles.mapMainWrapper}
      >
        <MapConsumer>
          {(map) => {
            if (mapBounds !== null) {
              map.fitBounds(mapBounds.pad(0.1));
            }

            return null;
          }}
        </MapConsumer>

        <DoubleClickComponent onSelectJobRequest={onSelectJobRequest} jobRequestsFilter={jobRequestsFilter} />

        {searchMapMarkerLocation !== null && dataSearch !== null ? (
          <Marker
            key={`${searchMapMarkerLocation.lat} ${searchMapMarkerLocation.lon}`}
            position={[searchMapMarkerLocation.lat, searchMapMarkerLocation.lon]}
            icon={getIconSearch("red")}
          >
            <Popup className="mapPopup">{dataSearch}</Popup>
          </Marker>
        ) : null}

        <MarkerClusterGroup iconCreateFunction={createClusterCustomIcon}>
          {jobRequests.map((x) => {
            return (
              <Marker key={x.id} position={[x.lat, x.lon]} icon={getIconJobRequest(x.jobRequestType)}>
                <Popup className="mapPopup">
                  <div style={{ color: jobRequestTypeColor[x.jobRequestType], display: "flex" }}>
                    <b>
                      <span>
                        {jobRequestType[x.jobRequestType]} {x.isWinter ? <AcUnitIcon fontSize="inherit" /> : ""}
                      </span>
                    </b>
                  </div>

                  <div>
                    <b>Наименование:</b> {x.title}
                  </div>
                  <div>
                    <b>Дата:</b> {x.date.split("T")[0]}
                  </div>

                  <div>
                    <b>Адрес:</b> {x.address}
                  </div>
                  <div>
                    <b>Комментарий:</b> {x.comment}
                  </div>
                </Popup>
              </Marker>
            );
          })}
        </MarkerClusterGroup>

        {mapBaseLayer.url.map((_url, index) => {
          return <TileLayer key={mapBaseLayer.name + index} url={_url} updateWhenIdle={true} maxZoom={mapBaseLayer.maxZoom} />;
        })}
      </MapContainer>

      <TopRightMapControl top="10px">
        <BaseLayerMapControl />
      </TopRightMapControl>

      <TopLefttMapControl>
        <SearchAddressControl />
      </TopLefttMapControl>
    </div>
  );
};

export default withJobRequests(withAppState(withMainMap(withGeocoder(withMapControl(JobRequestsMap)))));
